import React from "react";
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import { SearchProvider, WithSearch } from "@elastic/react-search-ui";
import "@elastic/react-search-ui-views/lib/styles/styles.css";

const connector = new AppSearchAPIConnector({
  searchKey: "--dummy-value--",
  engineName: document.getElementById("header-search")
    ? document.getElementById("header-search").dataset.engine
    : "--dummy-value--",
  endpointBase: "/_search-proxy",
  additionalHeaders: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
});

export default function AutoSuggestElasticSearchBox() {
  const formRef = React.createRef();
  const [suggestionSelected, setSuggestionSelected] = React.useState(false);
  React.useEffect(() => {
    if (suggestionSelected) {
      setSuggestionSelected(false);
      formRef.current.submit();
    }
  }, [suggestionSelected]);
  return (
    <SearchProvider
      config={{
        apiConnector: connector,
        autocompleteQuery: {
          suggestions: {
            size: 5
          }
        }
      }}
    >
      <WithSearch mapContextToProps={context => context}>
        {context => {
          const { autocompletedSuggestions } = context;
          const { documents: suggestions } = autocompletedSuggestions;
          const selectSuggestion = text => {
            context.setSearchTerm(text, { shouldClearFilters: true });
            setSuggestionSelected(true);
          };
          const handleTermChange = e => {
            context.setSearchTerm(e.target.value, {
              autocompleteSuggestions: true
            });
          };
          const activateSuggestion = e => {
            e.target.classList.add("suggestion-active");
            e.target.classList.remove("suggestion-inactive");
          };
          const deactivateSuggestion = e => {
            e.target.classList.add("suggestion-inactive");
            e.target.classList.remove("suggestion-active");
          };
          const handleKeyDown = e => {
            if (suggestions && suggestions.length > 0) {
              let index = parseInt(e.target.dataset.index, 10);
              switch (e.keyCode) {
                // Down arrow
                case 40:
                  e.view.event.preventDefault();
                  index += 1;
                  break;
                // Up arrow
                case 38:
                  e.view.event.preventDefault();
                  // If this is the searchbar
                  if (index === -1) {
                    index = 4;
                  } else {
                    index -= 1;
                  }
                  break;
                // ESC
                case 27:
                  setTimeout(() => {
                    document
                      .querySelector("div.header-site-top")
                      .classList.remove("header-search-active");
                  }, 200);
                  return;
                default:
                  break;
              }
              const targetId = `header-search-autosuggest-item-${index}`;
              const targetSuggestion = document.getElementById(targetId);
              if (targetSuggestion !== null) {
                targetSuggestion.focus();
              } else {
                document.querySelector("input.searchfield").focus();
              }
            }
          };
          return (
            <form
              id="HeaderSearchForm"
              action="/search/SearchForm"
              className="search-form flex"
              role="search"
              ref={formRef}
            >
              <input
                autoComplete="off"
                name="Search"
                aria-label="Search MBIE website"
                type="text"
                data-index="-1"
                className="text form-control searchfield input-lg"
                placeholder="Search MBIE"
                value={context.searchTerm}
                onChange={handleTermChange}
                onKeyDown={handleKeyDown}
              />
              <input
                type="submit"
                className="btn btn-primary search-btn"
                aria-label="Submit search query"
                value="Search"
              />
              {suggestions && suggestions.length > 0 ? (
                <ul
                  className="header-search-autosuggest"
                  id="header-search-autosuggest-list"
                >
                  <h6>Suggested queries:</h6>
                  {suggestions.map((suggest, index) => (
                    <li key={suggest.suggestion} tabIndex="-1">
                      <button
                        type="button"
                        data-index={index}
                        id={`header-search-autosuggest-item-${index}`}
                        className="header-search-autosuggest-item-button suggestion-inactive"
                        onClick={() => selectSuggestion(suggest.suggestion)}
                        onFocus={activateSuggestion}
                        onBlur={deactivateSuggestion}
                        onKeyDown={handleKeyDown}
                      >
                        {suggest.suggestion}
                      </button>
                    </li>
                  ))}
                </ul>
              ) : null}
            </form>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
}
